import { Box, Card, Grid, Typography, Divider, useTheme } from "@mui/material";

const CardPreServicioItem = ({item}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    return (
        <Card
            sx={{
                background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #1F2A40 100%)' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                boxShadow: isDarkMode ? '0 2px 12px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.5)' : '0 2px 12px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.08)',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid rgba(0, 0, 0, 0.1)',
                borderRadius: 3,
                p: 2,
                mt: 1.5,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    boxShadow: isDarkMode ? '0 4px 20px rgba(0, 0, 0, 0.4), 0 2px 6px rgba(0, 0, 0, 0.6)' : '0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.12)',
                    transform: 'translateY(-1px)'
                }
            }}
        >
            {/* Título Principal */}
            <Box sx={{ mb: 1.5 }}>
                <Typography 
                    variant="h6" 
                    sx={{
                        fontWeight: 600,
                        color: isDarkMode ? '#e0e0e0' : '#1a1a1a',
                        fontSize: { xs: 15, sm: 16 },
                        lineHeight: 1.3,
                        letterSpacing: '-0.01em'
                    }}
                >
                    {item?.nombreServicio_ds}
                </Typography>
            </Box>

            {/* Separador visual */}
            <Divider sx={{ mb: 1.5, borderColor: isDarkMode ? '#3d4a62' : 'rgba(0, 0, 0, 0.08)' }} />

            <Grid container spacing={1.5}>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: isDarkMode ? 'rgba(99, 102, 241, 0.15)' : 'rgba(99, 102, 241, 0.04)',
                        borderRadius: 1.5,
                        border: isDarkMode ? '2px solid rgba(99, 102, 241, 0.3)' : '2px solid rgba(99, 102, 241, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#a5b4fc' : '#6366f1',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Tipo de Servicio
                        </Typography>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.tipoServicio_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: isDarkMode ? 'rgba(16, 185, 129, 0.15)' : 'rgba(16, 185, 129, 0.04)',
                        borderRadius: 1.5,
                        border: isDarkMode ? '2px solid rgba(16, 185, 129, 0.3)' : '2px solid rgba(16, 185, 129, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#6ee7b7' : '#10b981',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Precio
                        </Typography>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#374151',
                                fontWeight: 600,
                                fontSize: 14,
                                lineHeight: 1.3
                            }}
                        >
                            {`${item?.importeServicio_ds || '0'} ${item?.moneda_ds || ''}`}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: isDarkMode ? 'rgba(245, 158, 11, 0.15)' : 'rgba(245, 158, 11, 0.04)',
                        borderRadius: 1.5,
                        border: isDarkMode ? '2px solid rgba(245, 158, 11, 0.3)' : '2px solid rgba(245, 158, 11, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#fbbf24' : '#f59e0b',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Cantidad
                        </Typography>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.cantidad_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.15)' : 'rgba(139, 92, 246, 0.04)',
                        borderRadius: 1.5,
                        border: isDarkMode ? '2px solid rgba(139, 92, 246, 0.3)' : '2px solid rgba(139, 92, 246, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#c4b5fd' : '#8b5cf6',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Vigencia
                        </Typography>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.vigencia_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: isDarkMode ? 'rgba(236, 72, 153, 0.15)' : 'rgba(236, 72, 153, 0.04)',
                        borderRadius: 1.5,
                        border: isDarkMode ? '2px solid rgba(236, 72, 153, 0.3)' : '2px solid rgba(236, 72, 153, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#f9a8d4' : '#ec4899',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Meses
                        </Typography>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.cantMeses_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                {/* Sección de Observaciones */}
                {item?.obs_ds && (
                    <Grid item xs={12}>
                        <Divider sx={{ my: 1, borderColor: isDarkMode ? '#3d4a62' : 'rgba(0, 0, 0, 0.08)' }} />
                        <Box sx={{ 
                            p: 1.5,
                            backgroundColor: isDarkMode ? 'rgba(107, 114, 128, 0.15)' : 'rgba(107, 114, 128, 0.04)',
                            borderRadius: 1.5,
                            border: isDarkMode ? '2px solid rgba(107, 114, 128, 0.3)' : '2px solid rgba(107, 114, 128, 0.08)',
                            borderLeft: isDarkMode ? '3px solid #9ca3af' : '3px solid #6b7280'
                        }}>
                            <Typography 
                                sx={{
                                    color: isDarkMode ? '#9ca3af' : '#6b7280',
                                    fontWeight: 600,
                                    fontSize: 10,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    mb: 0.5
                                }}
                            >
                                Observaciones
                            </Typography>
                            <Typography 
                                sx={{
                                    color: isDarkMode ? '#e0e0e0' : '#374151',
                                    fontWeight: 400,
                                    fontSize: 13,
                                    lineHeight: 1.4,
                                    fontStyle: item?.obs_ds ? 'normal' : 'italic'
                                }}
                            >
                                {item?.obs_ds || 'Sin observaciones adicionales'}
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Card>
    )
}

export default CardPreServicioItem